export default {
  group_checklist_items: []
}



// WEBPACK FOOTER //
// ./src/store/module/group-checklist-item/state.js